import { formatMoney } from "../util/numberUtils";

export const formattedCustomAnswer = (customAnswer) => {
  let answer = '';
  switch (customAnswer.custom_field.kind) {
    case 'list':
      const currentOption = customAnswer.custom_field.list_options.find((option) => (option.value === customAnswer.answer));
      answer = currentOption?.label || '';
      break;
    case 'date':
      answer = customAnswer.answer?.substring(0, 10) || '';
      break;
    case 'float':
      answer = formatMoney(customAnswer.answer);
      break;
    default:
      switch (customAnswer.answer) {
        case 'true':
          answer = 'Si';
          break;
        case 'false':
          answer = 'No';
          break;
        default:
          answer = customAnswer.answer;
      }
  }
  return answer;
};
